export default {
  pageTitle: 'その他設備の製作',
  metaDescription: 'TEFはデュプレックスステンレスや特殊合金を用いて、スクリューコンベア、攪拌機、インペラーなどの特殊産業機器を製作しています。',
  sidebar: {
    title: '製作リスト',
    vessel: 'ベッセル製作',
    heatExchanger: '熱交換器製作',
    piping: '配管製作',
    tower: '塔槽製作',
    muffle: 'マッフル製作',
    radiantTube: 'ラジアントチューブ製作',
    otherEquipment: 'その他設備製作',
  },
  fabricationOf: '製作',
  product: {
    name: 'その他の設備',
    desc: '以下は、当社のその他設備製作における各種材質・タイプ・仕様の実績カタログです。',
  },
};
